import * as Yup from 'yup';

/**
 * Check if the RichTextEditorField content is not empty
 */
Yup.addMethod(
  Yup.string,
  'richTextEditorContentRequired',
  function richTextEditorContentRequired(name?: string) {
    return this.test({
      name: 'richTextEditorContentRequired',
      message: {
        key: 'form.validation.required',
      },
      test: (_value, context) => {
        const contentElement = document.querySelector(
          `[data-testid="${name ?? context.path}-editable-area"]`,
        );

        return contentElement?.textContent?.trim().length !== 0;
      },
    });
  },
);
